import { z } from 'zod';

function isEmail(val: string) {
  return z.string().email().safeParse(val).success;
}

function isTelegram(val: string) {
  return /^@?[a-zA-Z0-9_]{4,32}$/.test(val);
}

export type LeadMagnetErrorMessages = {
  contactRequired: string;
  contactInvalid: string;
  consent: string;
};

export function createLeadMagnetSchema(m: LeadMagnetErrorMessages) {
  return z.object({
    contact: z
      .string()
      .min(1, m.contactRequired)
      .refine((val) => isEmail(val) || isTelegram(val), m.contactInvalid),
    consent: z.literal(true, { error: m.consent }),
  });
}

/** Серверная валидация: тексты ошибок наружу не отдаются, клиент показывает свои. */
export const leadMagnetSchema = createLeadMagnetSchema({
  contactRequired: 'contact required',
  contactInvalid: 'contact invalid',
  consent: 'consent required',
}).extend({
  locale: z.enum(['ru', 'en']).default('ru'),
});

export type LeadMagnetInput = z.infer<ReturnType<typeof createLeadMagnetSchema>>;

export function detectContactType(contact: string): 'email' | 'telegram' {
  return isEmail(contact) ? 'email' : 'telegram';
}
